import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import Modal from '../../lib/modal';
import DivButton from '../button/DivButton';

const Close = '/svg/close.svg';

Modal.defaultStyles.overlay.backgroundColor = 'rgba(0, 0, 0, 0.5)';

class AddonConfirmModal extends Component {
  render() {
    const { isModal, onClose, onAddOptions, onProceed, t, customItems } = this.props;

    return (
      <Modal
        ariaHideApp={false}
        isOpen={isModal}
        contentLabel="Addon Confirm"
        onRequestClose={onClose}
        style={styles.modal}
      >
        <DivButton style={styles.closeBtn} onClick={onClose}>
          <img src={Close} alt="close" />
        </DivButton>

        <div style={styles.content}>
          <div style={styles.iconContainer}>
            <div style={styles.questionIcon}>?</div>
          </div>

          <h2 style={styles.title}>
            {t('addonConfirmTitle') || 'Need Add-on Options?'}
          </h2>

          <p style={styles.message}>
            {t('addonConfirmMessage') ||
              "Don't you need any add-on options for your glove? Check out the add-on options available for customization!"}
          </p>

          {customItems && customItems.length > 0 && (
            <div style={styles.itemList}>
              <p style={styles.itemListTitle}>
                {t('addonConfirmItemsTitle') || 'Custom gloves in your cart:'}
              </p>
              {customItems.map((item, index) => (
                <div key={index} style={styles.itemRow}>
                  <img src={item.uri_pd} alt="" style={styles.itemImage} />
                  <span style={styles.itemName}>
                    {JSON.parse(item.body).title || 'Custom Glove'}
                  </span>
                  {item.addonData ? (
                    <span style={styles.addonAdded}>
                      {t('addonAdded') || 'Options Added'}
                    </span>
                  ) : (
                    <span style={styles.noAddon}>
                      {t('noAddonAdded') || 'No Options'}
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={styles.buttonContainer}>
          <DivButton
            style={styles.addOptionsBtn}
            onClick={onAddOptions}
          >
            <span>{t('addonConfirmAddBtn') || 'Add Options'}</span>
          </DivButton>

          <DivButton
            style={styles.proceedBtn}
            onClick={onProceed}
          >
            <span>{t('addonConfirmProceedBtn') || 'Proceed Without Options'}</span>
          </DivButton>
        </div>
      </Modal>
    );
  }
}

AddonConfirmModal.propTypes = {
  isModal: PropTypes.bool,
  onClose: PropTypes.func,
  onAddOptions: PropTypes.func,
  onProceed: PropTypes.func,
  t: PropTypes.func,
  customItems: PropTypes.array,
};

AddonConfirmModal.defaultProps = {
  isModal: false,
  onClose: () => {},
  onAddOptions: () => {},
  onProceed: () => {},
  t: (key) => key,
  customItems: [],
};

const styles = {
  modal: {
    content: {
      width: 480,
      maxHeight: '80vh',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: 0,
      borderRadius: 8,
      overflow: 'hidden',
    },
    overlay: {
      zIndex: 1000,
    },
  },
  closeBtn: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 10,
    cursor: 'pointer',
  },
  content: {
    padding: '40px 32px 24px',
    textAlign: 'center',
  },
  iconContainer: {
    marginBottom: 20,
  },
  questionIcon: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    backgroundColor: '#c77b46',
    color: '#fff',
    fontSize: 36,
    fontWeight: 'bold',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#251f1b',
    margin: '0 0 16px',
    fontFamily: 'Roboto Condensed',
  },
  message: {
    fontSize: 15,
    color: '#555',
    lineHeight: 1.6,
    margin: '0 0 20px',
  },
  itemList: {
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    padding: 16,
    textAlign: 'left',
  },
  itemListTitle: {
    fontSize: 13,
    color: '#666',
    marginBottom: 12,
  },
  itemRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
  itemImage: {
    width: 40,
    height: 40,
    objectFit: 'cover',
    borderRadius: 4,
    marginRight: 12,
  },
  itemName: {
    flex: 1,
    fontSize: 14,
    color: '#251f1b',
  },
  addonAdded: {
    fontSize: 12,
    color: '#40c380',
    fontWeight: '600',
  },
  noAddon: {
    fontSize: 12,
    color: '#e85454',
    fontWeight: '600',
  },
  buttonContainer: {
    padding: '16px 32px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  addOptionsBtn: {
    width: '100%',
    height: 52,
    backgroundColor: '#c77b46',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    fontWeight: '600',
    color: '#fff',
    cursor: 'pointer',
  },
  proceedBtn: {
    width: '100%',
    height: 52,
    border: '1px solid #251f1b',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    fontWeight: '600',
    color: '#251f1b',
    cursor: 'pointer',
    backgroundColor: '#fff',
  },
};

export default withTranslation('translations')(AddonConfirmModal);
